module.exports = __webpack_public_path__ + "static/media/as_item3_price.1baf5ab4.png";